import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE, EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,   
        EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
        EVENTS_STATISTICS_PRODUCER_ROUTE, } from "../../config/RoutesConstants"
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  Grid,
  GridList,
  GridListTile,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'

let _handleSubmitFail;
class StatisticsEvent extends React.PureComponent{
  constructor(props){
    super(props)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
 
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }



  renderTicketByType(){
    const {theme, stats} = this.props
    console.log("TICKET BY TYPE", stats)
    return stats.statsByType&&stats.statsByType.map((ticket,i)=>{
      return (
        <GridListTile style={theme.StatsCard.container}>
            <Grid container direction="row" style={{...theme.StatsCard.header.container, backgroundColor:ticket.tktColor}}>
              <Grid item xs={6}>
                <Typography style={{...theme.StatsCard.header.label, color:theme.palette.getContrastText(ticket.tktColor)}}>{ticket.tktProducerName&&ticket.tktProducerName.toUpperCase()}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography style={{...theme.StatsCard.header.value, color:theme.palette.getContrastText(ticket.tktColor)}}>Venta total: {Util.formatCurrency(ticket.tktTotalAmountSell)}</Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5}>
                <Typography style={theme.StatsCard.label}>Entradas en venta</Typography>
              </Grid>
              <Grid item xs={3} >
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktTotalQt)||0}</Typography>
              </Grid>
              <Grid item xs={4} >
                {/* <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktTotalToSell)||0}</Typography> */}
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5} >
                <Typography style={theme.StatsCard.label}>Vendidas por RRPP</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktTotalQtSellByRrpp)||0}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktTotalAmountSellByRrpp)||0}</Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5} >
                <Typography style={theme.StatsCard.label}>Vendidas por Productor</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktTotalQtSellByProductor)||0}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktTotalAmountSellByProductor)||0}</Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5} >
                <Typography style={theme.StatsCard.label}>Venta por Aplicación</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktTotalQtSellByApp)||0}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktTotalAmountSellByApp)||0}</Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5}>
                <Typography style={{...theme.StatsCard.label, color:"#03a900"}}>Vendidas</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{...theme.StatsCard.value, color:"#03a900"}}>{Util.formatNumber(ticket.tktTotalQtSell)||0}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography style={{...theme.StatsCard.value, color:"#03a900"}}>{Util.formatCurrency(ticket.tktTotalAmountSell)||0}</Typography>
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5}>
                <Typography style={theme.StatsCard.label}>Invitaciones</Typography>
              </Grid>
              <Grid item xs={3} >
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktGiftQt)||0}</Typography>
              </Grid>
              <Grid item xs={4} >
                {/* <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktGiftAmount)||0}</Typography> */}
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.row}>
              <Grid item xs={5}>
                <Typography style={theme.StatsCard.label}>Canjes</Typography>
              </Grid>
              <Grid item xs={3} >
                <Typography style={theme.StatsCard.value}>{Util.formatNumber(ticket.tktLoyalyQt)||0}</Typography>
              </Grid>
              <Grid item xs={4} >
                {/* <Typography style={theme.StatsCard.value}>{Util.formatCurrency(ticket.tktGiftAmount)||0}</Typography> */}
              </Grid>
            </Grid>
            <Grid container direction="row" style={theme.StatsCard.footer.container}>
              <Grid item xs={8}>
                <Typography style={theme.StatsCard.footer.label}>Ganancia de productor</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography  style={theme.StatsCard.footer.value}>{Util.formatCurrency(ticket.tktTotalAmountProducer)}</Typography>
              </Grid>
            </Grid>
        </GridListTile>
      )
    })
  }

  render(){
    const { theme, handleSubmit, history, stats, event } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Estadísticas</Typography>
            <Typography variant="subtitle1">Evento {event.evtName}</Typography>
          </Box>
        </Box>
        <Container maxWidth={1320}>        
          <Paper style={theme.paper.form}>
            <Typography variant="h2">{event.evtName}</Typography>
            <Grid container direction="row" spacing={3}>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktToSell.paper}>
                  <Typography style={theme.stats.tktToSell.label}>Entradas en venta</Typography>
                  <Typography style={theme.stats.tktToSell.value}>{Util.formatNumber(stats.statsTotalQt)||0}</Typography>
                  {/* <Typography style={theme.stats.tktToSell.value}>{Util.formatCurrency(stats.statsTotalToSell)||0}</Typography> */}
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSellRRPP.paper}>
                  <Typography style={theme.stats.tktSellRRPP.label}>Vendidas por RRPP</Typography>
                  <Box className="columns-row-between">
                    <Typography style={theme.stats.tktSellRRPP.value}>{Util.formatNumber(stats.statsTotalQtSellByRrpp)||0}</Typography>
                    <IconButton onClick={()=>{history.push(EVENTS_STATISTICS_DIRECT_RRPP_ROUTE)}} size="small">
                      <ArrowRightIcon style={theme.stats.tktSellRRPP.value}/>
                    </IconButton>
                  </Box>
                  <Typography style={theme.stats.tktSellRRPP.value}>{Util.formatCurrency(stats.statsTotalAmountSellByRrpp)||0}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSellRRPP.paper}>
                  <Typography style={theme.stats.tktSellRRPP.label}>Vendidas por Productor</Typography>
                  <Box className="columns-row-between">
                    <Typography style={theme.stats.tktSellRRPP.value}>{Util.formatNumber(stats.statsTotalQtSellByProductor)||0}</Typography>
                    <IconButton onClick={()=>{history.push(EVENTS_STATISTICS_PRODUCER_ROUTE)}} size="small">
                      <ArrowRightIcon style={theme.stats.tktSellRRPP.value}/>
                    </IconButton>
                  </Box>
                  <Typography style={theme.stats.tktSellRRPP.value}>{Util.formatCurrency(stats.statsTotalAmountSellByProductor)||0}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSellNoRRPP.paper}>
                  <Typography style={theme.stats.tktSellNoRRPP.label}>Venta por Aplicación</Typography>
                  <Typography style={theme.stats.tktSellNoRRPP.value}>{Util.formatNumber(stats.statsTotalQtSellByApp)||0}</Typography>
                  <Typography style={theme.stats.tktSellNoRRPP.value}>{Util.formatCurrency(stats.statsTotalAmountSellByApp)||0}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSold.paper}>
                  <Typography style={theme.stats.tktSold.label}>VENDIDAS</Typography>
                  <Typography style={theme.stats.tktSold.value}>{Util.formatNumber(stats.statsTotalQtSell)||0}</Typography>
                  <Typography style={theme.stats.tktSold.value}>{Util.formatCurrency(stats.statsTotalAmountSell)||0}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSellRRPP.paper}>
                  <Typography style={theme.stats.tktReferencedRRPP.label}>Referenciadas por RRPP</Typography>
                  <Box className="columns-row-between">
                    <Typography style={theme.stats.tktReferencedRRPP.value}>{Util.formatNumber(stats.statsTotalQtReferencedByRrpp)||0}</Typography>
                    <IconButton onClick={()=>{history.push(EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE)}} size="small">
                      <ArrowRightIcon style={theme.stats.tktReferencedRRPP.value}/>
                    </IconButton>
                  </Box>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.producer.paper}>
                  <Typography style={theme.stats.producer.label}>Ganancia de Productor</Typography>
                  <Typography style={theme.stats.producer.value}>{Util.formatCurrency(stats.statsTotalAmountProducer)}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSold.paper}>
                  <Typography style={theme.stats.tktGift.label}>INVITACIONES</Typography>
                  <Typography style={theme.stats.tktGift.value}>{Util.formatNumber(stats.statsGiftQt)||0}</Typography>
                </Paper>  
              </Grid>
              <Grid item xs={2}>
                <Paper style={theme.stats.tktSold.paper}>
                  <Typography style={theme.stats.tktLoyaly.label}>CANJES</Typography>
                  <Typography style={theme.stats.tktLoyaly.value}>{Util.formatNumber(stats.statsLoyalyQt)||0}</Typography>
                </Paper>  
              </Grid>
            </Grid>
            <Box style={theme.stats.titleDetail.box}>
              <Typography style={theme.stats.titleDetail.label}>DETALLE POR TIPO DE ENTRADA </Typography>
            </Box>
            <GridList cols={2} style={{justifyContent:"space-between"}}>
              {this.renderTicketByType()}
            </GridList>

          </Paper>
        </Container>
        
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE STATISTICS", store)
  return {
    login: store.auth.login,
    stats: store.evt.stats,
    event: store.evt.eventStats
    //eventPlace: store.form.addEditEvent
  };
}

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators(
//     {
//     },
//     dispatch
//   );
// }

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps
        // mapDispatchToProps
      )(StatisticsEvent)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/events/StatisticsEvent.js